import { notificationFilter } from '@/lib/notification'
import { mutePubkeySetAtom } from '@/atoms/lists'
import { useAtomValue } from 'jotai'
import { Event } from '@nostr/tools/wasm'
import * as kinds from '@nostr/tools/kinds'
import { useMemo } from 'react'
import { MentionNotification } from './MentionNotification'
import { PollResponseNotification } from './PollResponseNotification'
import { ReactionNotification } from './ReactionNotification'
import { RepostNotification } from './RepostNotification'
import { useCurrentPubkey } from '@/atoms/session'
export function NotificationItem({
  notification,
  isNew = false
}: {
  notification: Event
  isNew?: boolean
}) {
  const pubkey = useCurrentPubkey()
  const mutePubkeySet = useAtomValue(mutePubkeySetAtom)
  const canShow = useMemo(() => {
    return notificationFilter(notification, {
      pubkey,
      mutePubkeySet
    })
  }, [notification, mutePubkeySet])
  if (!canShow) return null

  if (notification.kind === kinds.Reaction) {
    return <ReactionNotification notification={notification} isNew={isNew} />
  }
  if (
    notification.kind === kinds.ShortTextNote ||
    notification.kind === kinds.Comment ||
    notification.kind === kinds.VoiceComment ||
    notification.kind === kinds.Poll
  ) {
    return <MentionNotification notification={notification} isNew={isNew} />
  }
  if (notification.kind === kinds.Repost) {
    return <RepostNotification notification={notification} isNew={isNew} />
  }
  if (notification.kind === kinds.PollResponse) {
    return <PollResponseNotification notification={notification} isNew={isNew} />
  }
  return null
}
